import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../cn.js';
import { Icon } from './Icon.js';
const PRESET = {
    // Colour is never the only cue: each state carries a distinct icon and its
    // own words, so the chip still reads on a monochrome display or to someone
    // who cannot separate the hues.
    unknown: {
        label: 'Unknown',
        icon: 'help',
        tone: 'bg-surface-container text-on-surface-variant border-outline-variant',
    },
    unavailable: {
        label: 'Unavailable',
        icon: 'cloud_off',
        tone: 'bg-tertiary-fixed text-on-tertiary-fixed border-tertiary-fixed-dim',
    },
    pending: {
        label: 'Pending',
        icon: 'sync',
        tone: 'bg-tertiary-fixed text-on-tertiary-fixed border-tertiary-fixed-dim',
    },
    applied: {
        label: 'Applied',
        icon: 'check_circle',
        tone: 'bg-secondary-container text-on-secondary-container border-secondary-fixed-dim',
    },
    failed: {
        label: 'Failed',
        icon: 'error',
        tone: 'bg-error-container text-on-error-container border-error',
    },
};
export function StatusChip({ state, label, detail, className }) {
    // `state` is a closed union and PRESET is a code-defined map with an entry
    // for each member. Not an injection sink — same reasoning as HERO_BY_MODE in
    // AdminDashboardPage.
    // eslint-disable-next-line security/detect-object-injection
    const preset = PRESET[state];
    const text = label ?? preset.label;
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 rounded-full border px-2 py-1 font-label-md text-label-md', preset.tone, className), title: detail, children: [_jsx(Icon, { name: preset.icon, "aria-hidden": "true", className: "text-[1rem] leading-none" }), _jsx("span", { children: text }), detail ? _jsxs("span", { className: "sr-only", children: [". ", detail] }) : null] }));
}
//# sourceMappingURL=StatusChip.js.map